import React from 'react';
import { FaThumbsDown, FaThumbsUp } from 'react-icons/fa';

import {
  ButtonsContainer,
  QualifierContainer,
  QualityButton,
  Title,
  TitleContainer,
  ViewsContainer,
} from './Qualifier.style';

interface QualifierProps {
  dicom: any;
  qualityLabel: any;
  setQualityLabel: (qualityLabel: any) => void;
}

const Qualifier = ({ dicom, qualityLabel, setQualityLabel }: QualifierProps) => {
  const goodQualityIsActive = qualityLabel?.qualityClass === 'GOOD';
  const badQualityIsActive = qualityLabel?.qualityClass === 'BAD';

  const handleQualityOnClick = (type: string) => {
    setQualityLabel({
      ...qualityLabel,
      dicom: dicom?.uuid,
      qualityClass: type,
    });
  };

  return (
    <QualifierContainer>
      <TitleContainer>Set Quality</TitleContainer>
      <ViewsContainer>
        <Title>Image Quality</Title>
        <ButtonsContainer>
          <QualityButton
            $type="GOOD"
            $isActive={goodQualityIsActive}
            onClick={() => handleQualityOnClick('GOOD')}
          >
            <FaThumbsUp />
          </QualityButton>
          <QualityButton
            $type="BAD"
            $isActive={badQualityIsActive}
            onClick={() => handleQualityOnClick('BAD')}
          >
            <FaThumbsDown />
          </QualityButton>
        </ButtonsContainer>
      </ViewsContainer>
    </QualifierContainer>
  );
};

export default Qualifier;
